import { useState } from "react";

const QUESTIONS = [
  {
    id: "recentChange",
    question: "Have you recently had a significant change in hearing loss?",
  },
  {
    id: "earPain",
    question: "Are you experiencing pain in your ears?",
  },
  {
    id: "dizziness",
    question: "Are you suffering from dizziness or vertigo?",
  },
  {
    id: "headInjury",
    question: "Have you recently suffered an injury or blow to the head?",
  },
  {
    id: "fluidLeak",
    question: "Have your ears actively leaked fluid in the last 90 days?",
  },
  {
    id: "earwax",
    question: "Do you currently have visible earwax buildup?",
  },
];

export default function HealthQuestionnaire({ onSubmit, onBack }) {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});

  const handleAnswer = (answer) => {
    const questionId = QUESTIONS[currentQuestion].id;
    const newAnswers = { ...answers, [questionId]: answer };
    setAnswers(newAnswers);

    if (currentQuestion < QUESTIONS.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    } else {
      onSubmit(newAnswers);
    }
  };

  const handleBack = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion((prev) => prev - 1);
    } else {
      onBack();
    }
  };

  const question = QUESTIONS[currentQuestion];
  const progress = ((currentQuestion + 1) / QUESTIONS.length) * 100;

  return (
    <div className="bg-[#111827] border border-[#1E2D3D] rounded-2xl p-6 sm:p-8 max-w-xl mx-auto">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#22D3EE] mb-2">
          Health Screening
        </p>
        <p className="text-[#64748B] text-sm">
          Question {currentQuestion + 1} of {QUESTIONS.length}
        </p>
        <div className="mt-3 h-1.5 bg-[#1E293B] rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-[#22D3EE] to-[#60A5FA] rounded-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <div className="mb-8">
        <h2
          className="text-xl sm:text-2xl font-medium text-[#F8FAFC] font-['Outfit']"
          data-testid="health-question-text"
        >
          {question.question}
        </h2>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <button
          onClick={() => handleAnswer(true)}
          className="flex-1 py-4 px-6 rounded-xl border-2 border-[#334155] text-[#F8FAFC] font-medium hover:border-[#FBBF24] hover:bg-[#FBBF24]/10 transition-all flex items-center justify-center gap-2"
          data-testid="health-yes-btn"
        >
          <svg
            className="w-5 h-5 text-[#FBBF24]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          Yes
        </button>
        <button
          onClick={() => handleAnswer(false)}
          className="flex-1 py-4 px-6 rounded-xl border-2 border-[#334155] text-[#F8FAFC] font-medium hover:border-[#34D399] hover:bg-[#34D399]/10 transition-all flex items-center justify-center gap-2"
          data-testid="health-no-btn"
        >
          <svg
            className="w-5 h-5 text-[#34D399]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          No
        </button>
      </div>

      <button
        onClick={handleBack}
        className="w-full py-3 px-6 rounded-lg border border-[#334155] text-[#94A3B8] font-medium hover:bg-[#1E293B] hover:text-[#F8FAFC] transition-colors flex items-center justify-center gap-2"
        data-testid="health-back-btn"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Back
      </button>
    </div>
  );
}
